import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function CollectionsBookmarkIcon(props: IconProps) {
    return <Icon {...props} iconKey={"collections_bookmark"}/>
}
